import { useIsOverflowing } from '@app/utils/hooks/useIsOverflowing';
import { SwatchData } from '@typings';
import cx from 'classnames';
import React from 'react';

import { CancelSmall } from '../Icons';
import { Tooltip } from '../Tooltip';

interface Props {
  name: string | JSX.Element;
  className?: string;
  swatchData?: SwatchData;
  onClick: VoidFunction;
}

export const FilterTag = ({ name, onClick, className }: Props) => {
  const nameRef = React.useRef<HTMLSpanElement>(null);
  const isNameOverflowing = useIsOverflowing(nameRef);

  return (
    <Tooltip content={isNameOverflowing && name}>
      <button
        className={cx(
          'relative flex items-center rounded-large bg-white py-0.5 pl-2 pr-5 text-start text-neutral-40 hover:bg-neutral-98 hover:text-neutral-20 focus-visible:bg-white focus-visible:focus-outline',
          className,
        )}
        onClick={onClick}
      >
        <span ref={nameRef} className="line-clamp-1 break-all body-5">
          {name}
        </span>
        <CancelSmall className="absolute right-0 mr-1 size-3" />
      </button>
    </Tooltip>
  );
};
